"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MagnifiedImagePosition = exports.DEFAULT_MAGNIFY_CONTAINER_WIDTH = exports.DEFAULT_MAGNIFY_CONTAINER_HEIGHT = exports.INTERACTIONS = exports.UNSET_ACTIVATION_TIMER_NAME = exports.SET_ACTIVATION_TIMER_NAME = exports.MOUSE_EMULATION_GUARD_TIMER_NAME = exports.TAP_GESTURE_TIMER_NAME = exports.PRESS_EVENT_TIMER_NAME = exports.DEFAULT_PORTAL_ID = exports.INPUT_TYPE = void 0;
exports.INPUT_TYPE = {
  mouse: 'mouse',
  touch: 'touch'
};
exports.DEFAULT_PORTAL_ID = 'react-image-magnify-portal';
exports.PRESS_EVENT_TIMER_NAME = 'pressEvent';
exports.TAP_GESTURE_TIMER_NAME = 'tap';
exports.MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
exports.SET_ACTIVATION_TIMER_NAME = 'setHovering';
exports.UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';
exports.INTERACTIONS = {
  touch: 'touch',
  tap: 'tap',
  press: 'press',
  click: 'click',
  hover: 'hover',
  doubleTap: 'double_tap'
};
exports.DEFAULT_MAGNIFY_CONTAINER_HEIGHT = '100%';
exports.DEFAULT_MAGNIFY_CONTAINER_WIDTH = '100%';
exports.MagnifiedImagePosition = {
  OVER: 'over',
  AUTO: 'auto',
  'AUTO-START': 'auto-start',
  'AUTO-END': 'auto-end',
  TOP: 'top',
  'TOP-START': 'top-start',
  'TOP-END': 'top-end',
  BOTTOM: 'bottom',
  'BOTTOM-START': 'bottom-start',
  'BOTTOM-END': 'bottom-end',
  RIGHT: 'right',
  'RIGHT-START': 'right-start',
  'RIGHT-END': 'right-end',
  LEFT: 'left',
  'LEFT-START': 'left-start',
  'LEFT-END': 'left-end'
};